import { createAction } from 'redux-actions'
import { saveAs } from 'file-saver'

import FileServices from '../../services/FileService'
import * as globalTypes from '../../actions/types'
import {
  fetchConfiguredTable,
  fetchUnsetConfiguredTable,
  resetUpdates,
} from '../Loads2/actions'

import LoadsService from './service'
import * as types from './types'
import { loadTablePaginationSize } from './utils'


export const clearReportFile = () => (
  (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
  }
)
export const fetchDataForTable = operationGroupIds => (dispatch, state) => {
  const data = {}
  const { status } = state().loadTable
  dispatch(createAction(types.CLEAR_STATUS)())
  dispatch(resetUpdates(0))
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))
  LoadsService.fetchLoadsForTable(operationGroupIds, 'negotiation', 1, status)
    .then((result) => {
      data.negotiation = result
    })
    .then(() =>
      LoadsService.fetchLoadsForTable(
        operationGroupIds,
        'in_progress',
        1,
        status,
      ),
    )
    .then((result) => {
      data.in_progress = result
      return LoadsService.fetchLoadsForTable(
        operationGroupIds,
        'delivered',
        1,
        status,
      ).then((result) => {
        data.delivered = result
        dispatch(createAction(types.FETCH_DATA_FROM_TABLE)(data))
      })
    })
    .finally(() =>
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
    )
}

export const cleanTableState = () => (dispatch) => {
  dispatch(createAction(types.CLEAN_TABLE_STATE)())
}
export const setConfiguredTable = (newConfigs, type, operationGroupIds) => (
  dispatch,
) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))
  LoadsService.setConfiguredTable(newConfigs, type.toUpperCase())
    .then((result) => {
      // dispatch(cleanTableState())
    })
    .then(() => {
      dispatch(fetchConfiguredTable())
      dispatch(fetchUnsetConfiguredTable())
      dispatch(fetchDataForTable(operationGroupIds))
    })
    .catch(err => console.log(err.message))
    .finally(() =>
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
    )
}

export const filterDataTable = (
  loadStatus,
  operationGroups,
  search = '',
  searchStatus = [],
  collectUF = '',
  deliveryUF = '',
  initCollectDate,
  endCollectDate,
  waitingAtLogisticOperator,
  trackingStatus,
  flProposalSended,
  flShippingNotViewed,
  flLotAvailable,
) => (dispatch, state) => {
  const { status } = state().loadTable
  const orderBy = state().loadTable.status[loadStatus].orderBy
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))
  const data = {}
  let fields
  if (loadStatus === 'negotiation' && searchStatus.length > 0) {
    fields = [...searchStatus]
  }

  if (loadStatus !== 'negotiation' && searchStatus.length > 0) {
    fields = [...searchStatus, status[loadStatus].searchStatus]
  }
  if (loadStatus !== 'negotiation' && !searchStatus.length) {
    fields = [...status[loadStatus].searchStatus]
  }
  const page = 1
  LoadsService.fetchLoadsByParams(
    loadStatus,
    operationGroups,
    search,
    page,
    10,
    fields,
    collectUF,
    deliveryUF,
    initCollectDate,
    endCollectDate,
    waitingAtLogisticOperator,
    loadStatus === 'negotiation' ? status.negotiation.launchType : [],
    loadStatus === 'in_progress' ? trackingStatus : '',
    flProposalSended,
    flShippingNotViewed,
    orderBy,
    flLotAvailable,
  )
    .then((result) => {
      if (result) {
        data[loadStatus] = result
        data.status = loadStatus
        data.page = page
        dispatch(createAction(types.FETCH_DATA_TABLE_WITH_PARAMS)(data))
      }
    })
    .finally(() =>
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
    )
}


export const fetchMoreData = (
  status,
  operationGroups,
  search,
  page,
  searchStatus,
  collectUF,
  deliveryUF,
  initCollectDate,
  endCollectDate,
  waitingAtLogisticOperator,
  trackingStatus,
  flProposalSended,
  flShippingNotViewed,
  flLotAvailable,
) => (dispatch, state) => {
  const fields = state().loadTable.status[status]
  const orderBy = state().loadTable.status[status].orderBy
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))
  if (status.toUpperCase() === 'NEGOTIATION') {
    LoadsService.fetchLoadsByParams(
      status,
      operationGroups,
      search,
      page,
      10,
      searchStatus,
      collectUF,
      deliveryUF,
      initCollectDate,
      endCollectDate,
      waitingAtLogisticOperator,
      fields.launchType,
      false,
      flProposalSended,
      flShippingNotViewed,
      orderBy,
      flLotAvailable,
    )
      .then((result) => {
        if (result) {
          dispatch(
            createAction(types.FETCH_MORE_DATA_ON_TABLE)({
              status,
              data: result,
              page,
            }),
          )
        }
      }).catch(err => console.log(err))
      .finally(() =>
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
      )
  } else {
    LoadsService.fetchLoadsByParams(
      status,
      operationGroups,
      search,
      page,
      10,
      fields.searchStatus,
      collectUF,
      deliveryUF,
      initCollectDate,
      endCollectDate,
      waitingAtLogisticOperator,
      false,
      status === 'in_progress' ? trackingStatus : false,
      flProposalSended,
      flShippingNotViewed,
      orderBy,
      flLotAvailable,
    ).then((result) => {
      if (result) {
        dispatch(
          createAction(types.FETCH_MORE_DATA_ON_TABLE)({
            status,
            data: result,
            page,
          }),
        )
      }
    }).catch(err => console.log(err)).finally(() => dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)))
  }
}

export const fetchDataByStatus = ({ status, size = loadTablePaginationSize, page = 1, ...payload }) => async (dispatch, state) => {
  const fields = state().loadTable.status[status]

  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))

  try {
    let servicePayload

    if (status.toUpperCase() === 'NEGOTIATION') {
      servicePayload = {
        ...payload,
        status: status.toUpperCase(),
        page,
        size,
        launchType: fields.launchType,
        trackingStatus: undefined,
      }
    } else {
      servicePayload = {
        ...payload,
        page,
        size,
        status: status.toUpperCase(),
        searchStatus: fields.searchStatus,
        trackingStatus: status === 'in_progress' ? payload.trackingStatus : undefined,
      }
    }

    const result = await LoadsService.fetchLoads(servicePayload)

    if (result) {
      dispatch(
        createAction(types.FETCH_DATA_BY_STATUS)({
          status,
          data: result,
          page,
        }),
      )
    }
  } catch (err) {
    console.error(err)
  } finally {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
  }
}

export const handleSelectedStatusChips = (
  type,
  status,
  operationgroups,
  search,
  searchStatus,
  collectUF,
  deliveryUF,
  initCollectDate,
  endCollectDate,
  waitingAtLogisticOperator,
  trackingStatus,
  flProposalSended,
  flShippingNotViewed,
  activeOrderBy,
  flLotAvailable,
) => (dispatch, state) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))
  // eslint-disable-next-line no-nested-ternary
  const orderBy = activeOrderBy ? state().loadTable.status[type].orderBy === null ? 'OLDER' : null : state().loadTable.status[type].orderBy

  if (type.toUpperCase() === 'NEGOTIATION') {
    const { launchType } = state().loadTable.status[type]
    if (launchType.includes(status)) {
      const filteredStatus = launchType.filter(item => (item !== status && item))
      dispatch(
        createAction(types.HANDLE_FAST_FILTER)({
          field: 'launchType',
          filter: filteredStatus,
          type,
          orderBy,
        }),
      )
    } else {
      const addFilter = [...launchType, status].filter(item => item)
      dispatch(
        createAction(types.HANDLE_FAST_FILTER)({
          field: 'launchType',
          filter: addFilter,
          type,
          orderBy,
        }),
      )
    }
    LoadsService.fetchLoadsByParams(
      'NEGOTIATION',
      operationgroups,
      search,
      1,
      10,
      searchStatus,
      collectUF,
      deliveryUF,
      initCollectDate,
      endCollectDate,
      waitingAtLogisticOperator,
      state().loadTable.status[type].launchType,
      false,
      flProposalSended,
      flShippingNotViewed,
      orderBy,
      flLotAvailable,
    )
      .then(r =>
        dispatch(
          createAction(types.CHANGE_FAST_FILTER)({ data: r, status: type }),
        ),
      )
      .catch(err => console.log(err))
      .finally(() =>
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
      )
  } else {
    const { searchStatus: fields } = state().loadTable.status[type]
    if (fields.includes(status)) {
      const filteredStatus = fields.filter(item => (item !== status && item))
      dispatch(
        createAction(types.HANDLE_FAST_FILTER)({
          field: 'searchStatus',
          filter: filteredStatus,
          type,
          orderBy,
        }),
      )
    } else {
      const addFilter = [...fields, status].filter(item => item)
      dispatch(
        createAction(types.HANDLE_FAST_FILTER)({
          field: 'searchStatus',
          filter: addFilter,
          type,
          orderBy,
        }),
      )
    }
    LoadsService.fetchLoadsByParams(
      type.toUpperCase(),
      operationgroups,
      search,
      1,
      10,
      state().loadTable.status[type].searchStatus,
      collectUF,
      deliveryUF,
      initCollectDate,
      endCollectDate,
      waitingAtLogisticOperator,
      false,
      type === 'in_progress' ? trackingStatus : false,
      flProposalSended,
      flShippingNotViewed,
      orderBy,
      flLotAvailable,
    )
      .then(r =>
        dispatch(
          createAction(types.CHANGE_FAST_FILTER)({ data: r, status: type }),
        ),
      )
      .catch(err => console.log(err))
      .finally(() =>
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
      )
  }
}

export const tableDownload = (
  status,
  operations,
  search,
  searchStatus,
  collectUF,
  deliveryUF,
  initCollectDate,
  endCollectDate,
  waitingAtLogisticOperator,
  trackingStatus,
  flProposalSended,
  flShippingNotViewed,
  flLotAvailable) => (dispatch, state) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))
  let newValue = []
  let newLaunchType = []
  const orderBy = state().loadTable.status[status].orderBy
  if (status !== 'negotiation' && searchStatus.length) {
    newValue = [...state().loadTable.status[status].searchStatus, ...searchStatus]
  }
  if (status === 'negotiation') {
    newLaunchType = [...state().loadTable.status.negotiation.launchType]
  }

  LoadsService.downloadByParams(status, operations, search, newValue, newLaunchType, collectUF, deliveryUF, initCollectDate, endCollectDate, waitingAtLogisticOperator, trackingStatus, flProposalSended, flShippingNotViewed, orderBy, flLotAvailable).then((file) => {
    const fileExtension = file ? file.split('.').pop() : ''
    const nameFileSplit = file ? file.split('/').pop().split('.', 1).pop() : ''
    const fileName = `${nameFileSplit}.${fileExtension}`


    FileServices
      .downloadAsBlob(file)
      .then((result) => {
        saveAs(result, fileName)
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
      })
      .finally(() => dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)))
  })
}

export const setViewTable = checked => (dispatch) => {
  dispatch(resetUpdates())
  dispatch(createAction(types.SET_VIEW_TABLE)({ checked }))
}

export const openNotification = (title, description) => (dispatch) => {
  dispatch(createAction(types.TABLE_NOTIFICATION)({
    title,
    description,
  }))
}

export const setTimer = (loadId, time) => (dispatch) => {
  dispatch(createAction(types.SET_TIMER)({ id: loadId, timer: time }))
}
export const setOffer = (loadId, offer) => (dispatch) => {
  dispatch(createAction(types.SET_OFFER_PRICE)({ id: loadId, offer }))
}

export const setLoadType = type => (dispatch) => {
  dispatch(createAction(types.SET_LOAD_TYPE)({ type }))
}
